export class InvitationInvalidStatusError extends Error {}

export const isInvitationInvalidStatusError = (e: unknown) =>
  e instanceof InvitationInvalidStatusError;
